import { render, staticRenderFns } from "./ApexCandlestickChart.vue?vue&type=template&id=53a022cd&"
import script from "./ApexCandlestickChart.vue?vue&type=script&lang=js&"
export * from "./ApexCandlestickChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports